import BaseInfoBox from "../entities/howtoplay/BaseInfoBox";

export default function resetScale(spr: BaseInfoBox) {
  spr.visible = false;
  spr.scale.set(spr.startScale);
}